import pipe from 'lodash/fp/pipe'
import split from 'lodash/fp/split'
import propOr from 'lodash/fp/propOr'

export const getVehicleRegistrationNoCountry = pipe<any, string, any, string>(
  propOr('', 'vehicle.detail.Registration'),
  split('|'),
  ([_, registration]) => registration
)

export const getMaintenancePeriods = propOr([], 'data.Data')
export const getWearPartsIntervals = propOr([], 'data.Data')

// Vehicle Linking Modal Selectors
export const getVehicleLinkingModalState = (state: any) =>
  state.vehicle?.linkingModal || {
    showConfirmModalLinkVehicle: false,
    showConfirmModalLinkAccount: false,
    receivedData: null
  }

export const getShowConfirmModalLinkVehicle = (state: any) => getVehicleLinkingModalState(state).showConfirmModalLinkVehicle

export const getShowConfirmModalLinkAccount = (state: any) => getVehicleLinkingModalState(state).showConfirmModalLinkAccount

export const getVehicleLinkReceivedData = (state: any) => getVehicleLinkingModalState(state).receivedData
